import i18next from 'i18next';
import enGB from '@locales/abscore/enGB';
import deAT from '@locales/abscore/deAT';

i18next.addResourceBundle('enGB', 'abscore', enGB);
i18next.addResourceBundle('deAT', 'abscore', deAT);